export const MODE_CFG = {
  "remote-sensing": { overline: "Remote Sensing", open: (id) => `/projects/${id}`, commodity: true, stats: true,
    empty: "Create a project, upload a licence boundary, and generate real satellite-derived mineral targets." },
  "maps": { overline: "Geomapping", open: (id) => `/maps/${id}`, commodity: false, stats: false,
    empty: "Create a project, upload a boundary, and generate professional geological & topographic map sheets." },
  "geophysics": { overline: "Geophysics", open: (id) => `/geophysics/${id}`, commodity: false, stats: false,
    empty: "Create a project and upload magnetic, gravity, IP, EM or radiometric data for processing & interpretation." },
};
